import React, { useState, useEffect } from "react";
import Select from "react-select/creatable"
import ReactSelect from 'react-select'
import { AvField } from 'availity-reactstrap-validation'

const createOption = (label) => ({
  label: label,
  value: label,
});

const defaultYearOption = () => {
    let option = []
    var d = new Date();
    var n = d.getFullYear();
    for(let i = n-20; i < n+10; i++) {
    	option.push(createOption(i))
    }

    return option
}

const defaultMonthOption = () => {
    let option = []
    option.push({ value: 1, label: 'Januari' });
    option.push({ value: 2, label: 'Februari' });
    option.push({ value: 3, label: 'Maret' });
    option.push({ value: 4, label: 'April' });
    option.push({ value: 5, label: 'Mei' });
    option.push({ value: 6, label: 'Juni' });
    option.push({ value: 7, label: 'Juli' });
    option.push({ value: 8, label: 'Agustus' });
    option.push({ value: 9, label: 'September' });
    option.push({ value: 10, label: 'Oktober' });
    option.push({ value: 11, label: 'November' });
    option.push({ value: 12, label: 'Desember' });

    return option;
}

export const YearSelect = (props) => {
    const [ selectedtValue, setSelectedValue ] = useState();
    const [ loading, setLoading ] = useState(false);
    const [ options, setOptions ] = useState(defaultYearOption())
    const { 
        name, 
        errorMessage, 
        defaultValue = new Date().getFullYear(), 
        validate, 
        onChange = null,
        onInputChange = null,
        isAvForm = true,
        isClearable,
        isSearchable = true,
        isDisabled,
        isLoading,
        isRtl,
        isMulti,
    } = props

    useEffect(() => {
        defaultVal(defaultValue)
    }, [defaultValue])

    const handleChange = (values) => {
        setSelectedValue(values)
        if(onChange) {
            onChange(values)
        }
    }

    const handleCreate = (inputValue) => {
        if (inputValue.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1')) {
            setLoading(true)
            setTimeout(() => {
                const newOption = createOption(inputValue)
                setLoading(false)
                setOptions([...options, newOption])
                setSelectedValue(newOption)
            }, 250)
        }
    }

    const defaultVal = (val) => {
        const filter = options.filter(option => option.value === val)
        setSelectedValue(filter[0])
    }

    return (
        <>
            <Select 
                isDisabled={loading}
                isLoading={loading}
                options={options} 
                onCreateOption={handleCreate}
                value={selectedtValue} 
                onChange={handleChange}
                isSearchable={isSearchable}
                isClearable={isClearable}
                isDisabled={isDisabled}
                isRtl={isRtl}
                isMulti={isMulti}
            />
            { isAvForm &&
                <AvField 
                    errorMessage={errorMessage}
                    name={name}
                    type="hidden" 
                    value={selectedtValue?.value} 
                    validate={validate}
                />
            }
        </>
    )
}

export const MonthSelect = (props) => {
    const [ selectedtValue, setSelectedValue ] = useState();
    const [ options, setOptions ] = useState(defaultMonthOption())
    const { 
        name, 
        errorMessage, 
        defaultValue = new Date().getMonth() + 1, 
        validate, 
        onChange = null,
        onInputChange = null,
        isClearable,
        isSearchable = true,
        isDisabled,
        isLoading,
        isRtl,
        isMulti,
        placeholder = "Select...",
        isAvForm = true
    } = props

    useEffect(() => {
        defaultVal(defaultValue)
    }, [defaultValue])

    const handleChange = (values) => {
        setSelectedValue(values)
        if(onChange) {
            onChange(values)
        }
    }

    const defaultVal = (val) => {
        const filter = options.filter(option => option.value === val)
        setSelectedValue(filter[0])
    }

    return (
        <>
            <ReactSelect 
                options={options} 
                value={selectedtValue} 
                onChange={handleChange}
                value={selectedtValue} 
                isSearchable={isSearchable}
                isClearable={isClearable}
                isDisabled={isDisabled}
                isLoading={isLoading}
                isRtl={isRtl}
                isMulti={isMulti}
            />
            { isAvForm &&
                <AvField 
                    errorMessage={errorMessage}
                    name={name}
                    type="hidden" 
                    value={selectedtValue?.value} 
                    validate={validate}
                />
            }
        </>
    )
}

export default YearSelect;